<template>
    <div class="login-page" v-if="isShow">
        <div class="dialog-mask"></div>
        <div class="login-content mask-content">
            <span class="close-icon" @click="closeLogin"></span>
            <div class="game-logo"></div>
            <div class="login-type">
                <span @click="changeLoginType('phone')" :class="{ active: loginType == 'phone' }">短信登录</span>
                <span @click="changeLoginType('wechat_web')" :class="{ active: loginType == 'wechat_web' }">微信登录</span>
            </div>
            <template v-if="loginType == 'phone'">
                <div class="form-wrap" key="phone">
                    <div class="input">
                        <input ref="phoneInput" type="text" v-model="phone" placeholder="请输入手机号" maxlength="11" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" />
                        <i class="error-tip" v-show="!isPhone">请输入11位手机号码</i>
                    </div>
                    <div class="input">
                        <input ref="codeInput" type="text" v-model="code" placeholder="请输入验证码" class="input-code" maxlength="6" @input="checkInputCode" @keyup="checkInputCode" @afterpaste="checkInputCode" />
                        <span :class="['get-code', isCountDown ? 'not-click' : '']" v-throttle="[getCode, 'click', 240]">
                            {{ isCountDown ? '倒计时' + formatTime(time) + 's' : '获取验证码' }}
                        </span>
                        <i class="error-tip" v-show="!isCode">请输入6位数字验证码</i>
                    </div>
                </div>
                <div :class="['login-btn', canClickLoginBtn ? '' : 'disabled']" v-throttle="[userLogin, 'click', 240]">
                    <i>登录</i>
                </div>
            </template>
            <template v-else-if="loginType == 'wechat'">
                <div class="qrcode-wrap" key="wechat">
                    <template>
                        <div class="qrcode" ref="wx-qrcode">
                            <img :src="qrcodeUrl" v-if="qrcodeUrl" />
                        </div>
                        <div class="qrcode-blank"></div>
                        <div class="qrcode-loading" v-if="loading">
                            <span class="icon"></span>
                        </div>
                        <div class="scan-line" v-if="showLine"></div>
                        <div class="qrcode-invalid" v-if="qrcodeIsValid == 2">
                            <div class="dv1">二维码已失效</div>
                            <div class="dv2" @click="refreshQrcode">刷新</div>
                        </div>
                        <div class="agree-cover" v-if="!agree">
                            <div class="dv1">请先阅读并同意<br />服务协议和隐私政策</div>
                        </div>
                    </template>
                </div>
            </template>
            <template v-else-if="loginType == 'wechat_web'">
                <div class="wechat-web-login qrcode-wrap" key="wechat_web">
                    <div id="login-container"></div>
                    <div class="qrcode-blank" v-show="agree">{{ wxWebLoginStatus == 1 ? '登录中...' : '' }}</div>
                    <div class="scan-line" v-if="showWebLine && wxWebLoginStatus != 2"></div>
                    <div class="qrcode-invalid" v-if="wxWebLoginStatus == 2">
                        <div class="dv1">登录失败</div>
                        <div class="dv2" @click="refreshWxQrcode">刷新</div>
                    </div>
                    <div class="agree-cover" v-if="!agree">
                        <div class="dv1">请先阅读并同意<br />服务协议和隐私政策</div>
                    </div>
                </div>
            </template>
            <div class="agree-protocol" :class="{ wechat_web: loginType == 'wechat_web' }" @animationend="animationend" ref="agree">
                <span :class="['circle', agree ? 'checked' : '']" @click="agreeProtocol"></span>
                <a @click="agreeProtocol" href="javascript:;">我已阅读并同意</a>
                <a class="a1" target="_blank" :href="userAgreement">《用户注册服务协议》</a>
                <a class="a1" target="_blank" :href="privacyPolicy">《用户隐私政策》</a>
            </div>
        </div>
    </div>
</template>

<script>
import { getSmsCode, smslogin, getWxTicket, getWxLoginToken, getWxTicketByCode } from '@/http/api/user'
import { checkUuid, setTokenToCookies, getCookieToken, getLoginPolicyVersion, setLoginPolicyVersion } from '@/utils/auth'
import QRCode from 'qrcodejs2'
import { cancelRequest } from '@/http'
import config from '@/http/config'
import { getCookie } from '@/utils/auth.js'
import { baiduOCPCReport } from '@/http/api/baidu.js'
import { ocpc360Report } from '@/http/api/360.js'

export default {
    name: 'LoginDialog',
    data() {
        return {
            graphUrl: '', // 首次加载滑块验证码背景图片
            agree: false,
            isShow: false,
            phone: '',
            code: '',
            isCountDown: false, // 是否在倒计时中
            time: 60, // 倒计时时间
            type: '', // 登录成功之后的操作
            payload: {}, // 显示弹框传递的参数
            loginType: 'wechat_web',
            showLine: false,
            loading: false, // 获取二维码加载状态
            qrcodeIsValid: -1, // 1-->有效 2-->无效
            qrcodeUrl: '',
            errorTimes: 0,
            showWebLine: false,
            wxWebLoginStatus: 2,
            callback: null,
            app_id: ''
        }
    },
    computed: {
        isPhone: function () {
            if (this.phone) {
                return this.phone.length < 11 ? false : true
            } else {
                return true
            }
        },
        isCode: function () {
            if (this.code) {
                return this.code.length < 6 ? false : true
            } else {
                return true
            }
        },
        canClickLoginBtn: function () {
            return /^1[3-9]\d{9}$/.test(this.phone) && /^\d{6}$/.test(this.code) && this.agree
        },
        userAgreement: function () {
            return this.$store.state.userAgreement
        },
        privacyPolicy: function () {
            return this.$store.state.privacyPolicy
        },
        policyVersion: function () {
            return this.$store.state.loginPolicyVersion
        }
    },
    watch: {
        policyVersion: function (value) {
            this.checkLoginPolicyVersion()
        },
        isShow: function (value) {
            if (!value) {
                this.$refs.agree.classList.remove('animate__shakeX')
                this.initData()
            } else {
                // 获取登录协议版本号
                this.$store.dispatch('getBoxProtocolVersion')

                this.$nextTick(() => {
                    this.$Utils.setDialogZindex('login-page')
                })

                this.payload = {}
                this.requestLogin = false
                this.loginType = 'wechat_web'
                this.resetWxWebData()
                clearTimeout(this.queryTokenTimeId)
                clearTimeout(this.wxQrcodeTimeId)
            }
        },
        loginType: function (value) {
            clearInterval(this.queryCodeTimeId)
            this.cancelRequest()
            if (value == 'wechat') {
                if (this.agree) {
                    this.getWxTicket()
                }
            } else if (value == 'wechat_web') {
                if (this.agree) {
                    this.resetWxWebData()
                    if (this.agree) {
                        this.initWechatQrcode()
                    }
                }
            } else {
                this.resetQrcode()
                this.$nextTick(() => {
                    if (this.$refs.phoneInput) {
                        this.$refs.phoneInput.focus()
                    }
                })
            }
        },
        agree: function (value) {
            clearInterval(this.queryCodeTimeId)
            this.cancelRequest()
            if (this.loginType == 'wechat') {
                if (value && this.qrcodeIsValid == -1) {
                    this.getWxTicket()
                } else {
                    this.resetQrcode()
                }
            } else if (this.loginType == 'wechat_web') {
                this.resetWxWebData()
                if (value) {
                    this.initWechatQrcode()
                }
            }
        }
    },
    methods: {
        initData() {
            this.agree = false
            this.isShow = false
            this.phone = ''
            this.code = ''
            this.isCountDown = false
            this.time = 60
            this.type = ''
            this.app_id = ''
        },
        show(type) {
            this.isShow = true
            // 参数说明 scene-->场景值，enter-page,表示登录之后需求跳转到某个页面
            this.type = type
            this.checkLoginPolicyVersion()
            const path = this.$router.currentRoute.path
            if (path == '/vip') {
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 8 })
            }
        },
        // 检查登录协议版本号
        checkLoginPolicyVersion() {
            if (!this.isShow) {
                return
            }
            var lastVersion = getLoginPolicyVersion()
            if (lastVersion != this.policyVersion) {
                this.agree = false
                this.$cookies.remove('agree-potocol')
            } else if (getCookie('agree-potocol') === '1') {
                this.agree = true
            }
        },
        checkInputCode(event) {
            let inputValue = this.code
            inputValue = inputValue.replace(/[^0-9]/g, '')
            if (inputValue.length > 6) {
                inputValue = inputValue.slice(0, 11)
            }
            this.code = inputValue

            if (event.key == 'Enter' || event.keyCode == 13 || event.code == 'Enter') {
                this.userLogin()
            }
        },
        getCode() {
            if (this.isCountDown) {
                return false
            } else if (!this.phone) {
                return this.$Toast.show('手机号码不能为空')
            } else if (!/^1[3-9]\d{9}$/.test(this.phone)) {
                return this.$Toast.show('手机号码格式输入错误，请检查后重新输入')
            } else {
                // 等滑块验证码背景图片完全加载出来才显示
                this.graphTimeid = setInterval(() => {
                    let img = $('.verify-img-panel img')
                    if (img) {
                        clearInterval(this.graphTimeid)
                        $('.verify-img-panel img').load(function () {
                            $(this).addClass('show')
                        })
                    }
                }, 100)

                sliderVerify(
                    'pop',
                    async (res) => {
                        if (res.token && res.captchaVerification) {
                            const data = {
                                userName: this.phone,
                                token: res.token,
                                captchaVerification: res.captchaVerification,
                                form: 'box'
                            }

                            // 发送短信验证码
                            getSmsCode(data).then((res) => {
                                if (res.code == 200 && this.$Utils.isObject(res.data)) {
                                    this.$refs.codeInput.focus()
                                    this.checkCodeSessionKey = res.data.checkCodeSessionKey
                                    this.isCountDown = true
                                    this.countDown()
                                } else {
                                    setTimeout(() => {
                                        this.$NormalDialog.show({ msg: res.msg, title: '提示' })
                                    }, 1200)
                                }
                            })
                        }
                    },
                    {
                        appKey: '42645'
                    }
                )
            }
        },
        // 倒计时
        countDown() {
            clearTimeout(this.timeId)
            if (this.time > 0) {
                this.timeId = setTimeout(() => {
                    this.time--
                    this.countDown()
                }, 1000)
            } else {
                this.time = 60
                this.isCountDown = false
            }
        },
        // 倒计时补0
        formatTime(time) {
            if (time < 10) {
                return '0' + time
            } else {
                return time
            }
        },
        // 用户登录
        userLogin() {
            if (!this.canClickLoginBtn) {
                if (!this.phone) {
                    return this.$Toast.show('手机号码不能为空')
                } else if (!/^1[3-9]\d{9}$/.test(this.phone)) {
                    return this.$Toast.show('手机号码格式输入错误，请检查后重新输入')
                } else if (!/^\d{6}$/.test(this.code)) {
                    return this.$Toast.show('请输入六位数字验证码')
                } else if (!this.agree) {
                    this.$refs.agree.classList.add('animate__shakeX')
                    return this.$Toast.show('请先同意用户注册服务协议和用户隐私政策')
                }
                return false
            }

            const data = {
                userName: this.phone,
                code: this.code,
                checkCodeSessionKey: this.checkCodeSessionKey || '',
                channel: this.$store.state.clientInfo.channel || '',
                uuid: checkUuid() || '',
                system: 'box',
                remoteip: this.$store.state.client_ip,
                bd_vid: this.$cookies.get('bd_vid') || '',
                game_id: parseInt(this.$cookies.get('box_website_game_id')) || 0
            }

            if (this.requestLogin) {
                return false
            }
            this.requestLogin = true
            smslogin(data)
                .then((res) => {
                    this.requestLogin = false
                    if (res.code == 200) {
                        this.afterLoginOp(res)
                    } else {
                        this.$Toast.show(res.msg)
                    }
                })
                .catch((err) => {
                    this.requestLogin = false
                })
        },
        agreeProtocol() {
            this.agree = !this.agree
            if (this.agree) {
                // 同意的协议版本号
                setLoginPolicyVersion(this.policyVersion)
                this.$cookies.set('agree-potocol', 1, -1)
            } else {
                this.$cookies.remove('agree-potocol')
            }
        },
        animationend() {
            this.$refs.agree.classList.remove('animate__shakeX')
        },
        changeLoginType(value) {
            this.loginType = value
        },
        afterLoginOp(res) {
            this.isShow = false
            this.$Toast.show('登录成功')
            setTokenToCookies(res.data.token)
            this.$store.commit('setToken', res.data.token)
            this.$store.dispatch('userBasicInfoAction', this.type)
            this.$store.dispatch('userVipInfoAction')
            this.$store.dispatch('userAuthInfoAction')
            this.$store.dispatch('authConfigAction')
            this.$store.dispatch('userPayConfigAction')
            // 协议更新检测（只检测老用户）
            if (!res.data.isReg) {
                this.$Utils.shouldShowAgreementUpdateDialog()
            }
            // 在其他页面登录成功，需获取免费时长信息，游戏详情页面，有登录成功的回调可以获取剩余免费时长
            if (this.$router.currentRoute.path !== '/detail') {
                this.$store.dispatch('getLimitFreeTime')
            }

            // 登录成功之后获取支付配置信息
            this.$EventBus.$emit('get-pay-config')

            // 进入需要登录的页面，登录成功之后回跳过去
            if (this.type instanceof Object) {
                const { scene, value, callback } = this.type
                console.log('Login=======>', '[scene]=', scene, '[value]=', value, callback)
                if (scene == 'open-xunyou-jiasuqi') {
                    const msg = `请确认是否使用当前账号注册/登录迅游加速器`
                    this.$NormalDialog.show({
                        msg,
                        showConfirm: true,
                        confirmTxt: '确定',
                        confirmFn: () => {
                            this.$EventBus.$emit('getStartXunYouParams')
                        }
                    })
                } else if (scene == 'enter-page') {
                    this.$router.push(value)
                } else if (scene == 'open-order-center') {
                    const url = `token=${getCookieToken()}&isReg=1`
                    window.open(`/redirect.html?${url}`, '_blank')
                } else if (scene == 'cb') {
                    if (callback && callback instanceof Function) {
                        callback()
                    }
                }
            }

            if (this.loginType == 'phone') {
            } else if (this.loginType == 'wechat_web') {
            }

            if (this.$router.currentRoute.path.indexOf('/detail') > -1) {
            }

            // 百度数据上报
            this.baiduReport(res.data.isReg)
        },
        resetQrcode() {
            clearTimeout(this.queryTokenTimeId)
            clearTimeout(this.wxQrcodeTimeId)
            clearTimeout(this.queryRetryTimeId)
            this.loading = false
            this.showLine = false
            this.qrcodeIsValid = -1
            this.qrcodeUrl = ''
            /*
            if (this.$refs['wx-qrcode']) {
                this.$refs['wx-qrcode'].innerHTML = ""
            }
            */
        },
        getWxTicket() {
            this.loading = true
            const data = {
                channel: this.$store.state.clientInfo.channel || '',
                system: 'box',
                uuid: checkUuid(),
                remoteip: this.$store.state.client_ip
            }
            getWxTicket(data)
                .then((res) => {
                    if (res.code == 200) {
                        const { ticket, expire_seconds } = res.data
                        const url = `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${ticket}`
                        // 不能用返回的地址生成二维码，微信扫描之后返回的是一个二维码图片
                        /*
                            this.$refs['wx-qrcode'].innerHTML = ""
                            this.creatQrCode(url)
                        */
                        this.loadImage(url, () => {
                            this.loading = false
                            this.qrcodeIsValid = 1
                            this.showLine = true
                            this.qrcodeUrl = url
                            this.queryWxTokenByTicket(ticket)
                            this.wxQrcodeTimeId = setTimeout(() => {
                                this.qrcodeIsValid = 2
                                this.showLine = false
                                clearTimeout(this.wxQrcodeTimeId)
                                clearTimeout(this.queryTokenTimeId)
                                clearTimeout(this.queryRetryTimeId)
                            }, expire_seconds * 1000)
                        })
                    } else {
                        this.$Toast.show(res.msg)
                    }
                })
                .catch(() => {
                    this.$Toast.show('获取二维码失败')
                    this.loading = false
                })
        },
        creatQrCode(url) {
            this.qrcode = new QRCode(this.$refs['wx-qrcode'], {
                text: url,
                width: 152,
                height: 152,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
            this.$nextTick(() => {
                this.$refs['wx-qrcode'].title = ''
            })
        },
        queryWxTokenByTicket(ticket) {
            clearTimeout(this.queryTokenTimeId)
            getWxLoginToken({ ticket })
                .then((res) => {
                    if (res.code == 200) {
                        clearTimeout(this.queryTokenTimeId)
                        this.afterLoginOp(res)
                    } else {
                        this.queryTokenTimeId = setTimeout(() => {
                            this.queryWxTokenByTicket(ticket)
                        }, 1000)
                    }
                })
                .catch(() => {
                    // 网络错误、服务器挂了等其他情况，3s后重试，重试次数最大60次
                    clearTimeout(this.queryRetryTimeId)
                    this.errorTimes++
                    if (this.errorTimes < 60) {
                        this.queryRetryTimeId = setTimeout(() => {
                            this.queryWxTokenByTicket(ticket)
                        }, 3000)
                    } else {
                        clearTimeout(this.queryTokenTimeId)
                        this.$Toast.show('获取token失败')
                    }
                })
        },
        refreshQrcode() {
            if (!this.agree) {
                this.$Toast.show('请先同意用户注册服务协议和用户隐私政策')
            }
            this.resetQrcode()
            this.getWxTicket()
        },
        cancelRequest() {
            cancelRequest('/user/wx/ticket')
            cancelRequest('/user/getTokenForTicket')
        },
        loadImage(url, fn) {
            const img = new Image()
            img.src = url
            img.addEventListener('load', function () {
                fn && fn()
            })
            img.addEventListener('error', function () {
                this.$Toast.show('加载二维码失败')
            })
        },
        getWechatWebLoginAppid() {
            const defaultAppid = 'wx5ad4b355ad9491fc'
            const urlParams = this.$Utils.getUrlParams()
            // 调试时可通过 ?wxLoginAppid=xxx 或 localStorage['wx-login-debug-appid'] 覆盖默认 appid
            const debugAppid = ((urlParams && urlParams.wxLoginAppid) || window.localStorage.getItem('wx-login-debug-appid') || '').trim()

            if (debugAppid) {
                console.log('[wx-login] use debug appid:', debugAppid)
                return debugAppid
            }

            return defaultAppid
        },
        initWechatQrcode() {
            this.showWebLine = true
            this.wxWebLoginStatus = -1
            clearInterval(this.queryCodeTimeId)
            this.$nextTick(async () => {
                // 新主体拾游魔方appid=wx5ad4b355ad9491fc
                // 老主体乐速商城appid=wxfd107a6775a8d1e5
                // 微信扫码登录统一使用新主体 APPID，保留原主体切换逻辑便于后续回溯
                // const result = await this.$Utils.useNewWechatSubject()
                // const appid = result ? 'wx5ad4b355ad9491fc' : 'wxfd107a6775a8d1e5'
                const appid = 'wx5ad4b355ad9491fc'
                this.app_id = appid
                var redirect_uri = encodeURIComponent(config.WEIXIN_LOGIN_DOMAIN + '/wechatLoginCallback.html')
                new WxLogin({
                    self_redirect: true,
                    id: 'login-container',
                    appid: appid,
                    scope: 'snsapi_login',
                    redirect_uri: redirect_uri,
                    stylelite: 1,
                    state: Date.now()
                })
            })

            this.queryCodeTimeId = setInterval(() => {
                let code = this.$cookies.get('ls-wechat-code')
                console.log('code=======>', code)
                if (code) {
                    this.showWebLine = false
                    this.wxCode = code
                    this.wxWebLoginStatus = 1
                    clearInterval(this.queryCodeTimeId)
                    this.$cookies.remove('ls-wechat-code', '', 'steamf.cn')
                    this.weixinWebLogin()
                }
            }, 1000)
        },
        resetWxWebData() {
            const loginContainerDom = document.getElementById('login-container')
            this.$cookies.remove('ls-wechat-code', '', 'steamf.cn')
            this.wxWebLoginStatus = -1
            this.showWebLine = false
            this.wxCode = ''
            clearInterval(this.queryCodeTimeId)
            loginContainerDom && (loginContainerDom.innerHTML = '')
        },
        refreshWxQrcode() {
            if (this.agree) {
                this.initWechatQrcode()
            } else {
                this.$refs.agree.classList.add('animate__shakeX')
                this.$Toast.show('请先同意用户注册服务协议和用户隐私政策')
            }
        },
        weixinWebLogin() {
            let query = {
                channel: this.$store.state.clientInfo.channel || '',
                system: 'box',
                uuid: checkUuid() || '',
                remoteip: this.$store.state.client_ip,
                code: this.wxCode,
                bd_vid: this.$cookies.get('bd_vid') || '',
                game_id: parseInt(this.$cookies.get('box_website_game_id')) || 0,
                // 登录换 token 同样固定使用新主体，保留原动态参数逻辑便于后续回溯
                // is_old: this.$Utils.getUrlParams().wxLoginAppid ? 1 : 0,
                // app_id: this.app_id
                is_old: 0,
                app_id: 'wx5ad4b355ad9491fc'
            }
            getWxTicketByCode(query).then((res) => {
                if (res.code == 200) {
                    this.afterLoginOp(res)
                } else {
                    this.showWebLine = false
                    this.wxWebLoginStatus = 2
                    this.$Toast.show(res.msg)
                }
            })
        },
        closeLogin() {
            this.isShow = false
        },
        baiduReport(isReg) {
            const bd_vid = this.$cookies.get('bd_vid')
            const qhclickid = this.$cookies.get('qhclickid')
            const channel = this.$cookies.get('steamf-gamebox-channel')
            const channels = ['baidudyy', 'bangyoua', 'bangyoul']
            const channels1 = ['360s']
            if (isReg) {
                this.$Utils.report({ event_id: 57, event: '百度OCPC数据上报', v1: 'receive' })
            }

            // 注册的才上报，并且有bd_vid、并且在指定渠道
            if (isReg && bd_vid && channels.includes(channel)) {
                const data = [
                    {
                        logidUrl: this.$Utils.appendParametersToUrl(window.location.href, {
                            bd_vid: bd_vid
                        }),
                        newType: 25
                    }
                ]
                this.$Utils.report({ event_id: 57, event: '百度OCPC数据上报', v1: 'send' })
                baiduOCPCReport(data)
                // 读取缓存中的游戏id
                const { game_id: queryGameId } = this.$route.query
                const { game_id: paramGameId } = this.$route.params
                const gameId = queryGameId || paramGameId || this.$cookies.get('box_website_game_id') || 0
                this.$Utils.report({ event: 'ocpc上报', event_id: 40, n2: gameId, v1: 'reg', v2: bd_vid, v3: 'box_web' })
            }

            // 注册的才上报，并且有bd_vid、并且在指定渠道
            if (isReg && qhclickid && channels1.includes(channel)) {
                const data = {
                    raw: JSON.stringify({
                        data: {
                            request_time: parseInt(Date.now() / 1000),
                            data_industry: 'ocpc_ps_convert',
                            data_detail: {
                                qhclickid,
                                event: 'REGISTERED'
                            }
                        }
                    })
                }
                ocpc360Report(data)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.login-page {
    .login-content {
        padding-top: 60px;
        width: 600px;
        height: 400px;
        background: url(../../../assets/dialog/login-bg.png) center/100% no-repeat;

        .login-type {
            display: flex;
            justify-content: center;
            color: @color-txt-high;
            font-size: 18px;
            line-height: 18px;

            span {
                cursor: pointer;
            }

            span.active {
                position: relative;
                color: @main-green-color2;

                &::after {
                    content: '';
                    position: absolute;
                    top: 24px;
                    width: 30px;
                    left: 50%;
                    margin-left: -15px;
                    height: 4px;
                    background: linear-gradient(125deg, #00f14e, #02cb8a);
                    border-radius: 2px;
                }
            }

            span:first-child {
                margin-right: 59px;
            }
        }

        .form-wrap {
            margin-top: 44px;
            margin-bottom: 32px;

            .input {
                position: relative;
                margin: 0 auto 20px;
                width: 360px;
                height: 40px;

                input {
                    width: 100%;
                    height: 100%;
                    line-height: 40px;
                    outline: none;
                    padding: 0 20px;
                    color: @color-txt-high;
                    border-radius: 20px;
                    border: none;
                    background: #090e0f;
                    font-size: 14px;

                    &::placeholder {
                        color: @color-txt-66;
                    }

                    &:focus {
                        background: url(../../../assets/input-bg.png) center/100% no-repeat;
                    }

                    &.input-code {
                        padding: 0 118px 0 24px;
                    }
                }

                .get-code {
                    position: absolute;
                    width: 118px;
                    height: 100%;
                    top: 0;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: @color-txt-normal;
                    font-size: 14px;
                    line-height: 22px;
                    cursor: pointer;
                    user-select: none;

                    &:hover {
                        color: @color-txt-high;
                    }

                    &.not-click {
                        cursor: not-allowed;
                    }
                }

                .error-tip {
                    position: absolute;
                    top: 40px;
                    left: 24px;
                    font-size: 12px;
                    color: #fef563;
                }
            }
        }

        .qrcode-wrap {
            margin: 40px auto 0;
            width: 170px;
            height: 170px;
            position: relative;
            background: url(../../../assets/dialog/qrcode-bg.png) center/100% no-repeat;

            .qrcode-blank,
            .qrcode-loading {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 146px;
                height: 146px;
                background: #fff;
                z-index: 1;
                border-radius: 10px;
            }

            .qrcode-loading {
                z-index: 3;

                .icon {
                    width: 32px;
                    height: 32px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background: url(../../../assets/dialog/loading.gif) center/100% no-repeat;
                }
            }

            .scan-line {
                position: absolute;
                left: 0;
                top: 0;
                z-index: 5;
                width: 100%;
                height: 30px;
                background: linear-gradient(0deg, rgba(58, 255, 255, 0.4) 0%, rgba(58, 255, 255, 0) 100%);
                animation: scan 4s linear infinite;
            }

            .qrcode-invalid,
            .agree-cover {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 146px;
                height: 146px;
                z-index: 2;
                padding-top: 44px;

                .dv1 {
                    text-align: center;
                    line-height: 23px;
                    color: #ffffff;
                    font-size: 18px;
                    user-select: none;
                }

                .dv2 {
                    margin: 17px auto 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 96px;
                    height: 32px;
                    border-radius: 16px;
                    background: linear-gradient(90.64deg, #ffe0c1 0.41%, #f2ab74 100.09%);
                    color: #6b3d1e;
                    font-size: 16px;
                    cursor: pointer;
                }
            }

            .qrcode-invalid {
                z-index: 6;
                background: @bg-color-00;
                border-radius: 8px;
            }

            .agree-cover {
                padding-top: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #090e0f;
                border-radius: 8px;

                .dv1 {
                    font-size: 14px;
                    line-height: 17px;
                    color: @color-txt-normal;
                }
            }

            .qrcode {
                position: absolute;
                width: 152px;
                height: 152px;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 2;
                overflow: hidden;

                ::v-deep img {
                    transform: scale(1.1);
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .login-btn {
            margin: 74px auto 0;
            font-weight: bold;
            .button-linear();
        }

        .agree-protocol {
            position: absolute;
            width: 100%;
            bottom: 144px;
            font-size: 0;
            text-align: center;

            &.wechat_web {
                bottom: 65px;
            }

            .circle {
                position: relative;
                top: 2px;
                cursor: pointer;
                display: inline-block;
                margin-right: 6px;
                width: 14px;
                height: 14px;
                background: url(../../../assets/rd.png) center/100% no-repeat;

                &:hover {
                    background-image: url(../../../assets/rd_1.png);
                }

                &.checked {
                    &::after {
                        position: absolute;
                        left: 0;
                        top: -4px;
                        content: '';
                        width: 16px;
                        height: 15px;
                        background: url(../../../assets/rd_chekd.png) center/100% no-repeat;
                    }
                }
            }

            a {
                text-decoration: none;
                color: @color-txt-normal;
                font-size: 12px;

                &.a1 {
                    color: @color-txt-high;
                }
            }
        }
    }
}

.animate__shakeX {
    animation: shakeX 1s linear 1;
}

@keyframes shakeX {
    0%,
    to {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }

    10%,
    30%,
    50%,
    70%,
    90% {
        -webkit-transform: translate3d(-10px, 0, 0);
        transform: translate3d(-10px, 0, 0);
    }

    20%,
    40%,
    60%,
    80% {
        -webkit-transform: translate3d(10px, 0, 0);
        transform: translate3d(10px, 0, 0);
    }
}

@keyframes scan {
    0% {
        transform: translateY(0);
        opacity: 0;
    }

    10% {
        opacity: 0.8;
    }

    50% {
        opacity: 1;
    }

    90% {
        opacity: 0.8;
    }

    100% {
        opacity: 0;
        transform: translateY(144px);
    }
}

/deep/ #login-container iframe {
    position: relative;
    z-index: 5;
    width: 200px;
    height: 200px;
    overflow: hidden;
    margin-top: 3px;
    margin-left: -13px;
    transform: scale(0.89);
}

.wechat-web-login .qrcode-invalid {
    z-index: 20;
}

.wechat-web-login .qrcode-blank {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
